import { Component, Inject, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from '../../models'
import { Permissions } from '../../enums/permissions.enum'

@Component({
  selector: 'app-app-selection',
  templateUrl: './app-selection.component.html',
  styleUrls: ['./app-selection.component.scss'],
  standalone: false,
})
export class AppSelectionComponent implements OnInit {
  Permissions = Permissions
  isContentVisible: boolean = false
  currentApp: string = ''
  isInternalEnabled: boolean = false
  isCustomerViewEnabled: boolean = false

  constructor(
    private route: Router,
    @Inject(APP_CONFIG) public readonly config: AppConfigModel,
  ) {}

  ngOnInit(): void {
    this.route.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      const routerEvent: NavigationEnd = event as any as NavigationEnd
      this.isInternalEnabled =
        routerEvent.url.includes('internal') || routerEvent.urlAfterRedirects.includes('internal')
          ? true
          : false

      this.isCustomerViewEnabled =
        routerEvent.url.includes('customer') || routerEvent.urlAfterRedirects.includes('customer')
          ? true
          : false
    })
  }

  toggleContent() {
    this.isContentVisible = !this.isContentVisible
  }

  hideContent() {
    this.isContentVisible = false
  }
}
